import { Fragment } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { getForms } from '../Forms/ApiForms';
import { getRoles } from '../Users/Roles/ApiRoles';

export default function RolesList(props) {
  //TODO
  //   Error while searching by name
  const { languageId, setFieldValue, roleName } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [searchParam, setSearchParam] = useState('');
  const { t } = useTranslation();
  const onSearchParam = (e) => {
    setSearchParam(e.target.value);
  };
  const PagesinitialData = {
    pageNumber: 1,
    pageSize: 1,
    isPaging: false,
    langId: languageId,
  };
  // Query Data To Fetch Languages
  const { data, isLoading, isError } = useQuery(['Roles', PagesinitialData], getRoles, {
    staleTime: 360000000,
  });
  if (isLoading) return '';
  if (isError) return 'error';
  const onClick = (data) => {
    setFieldValue('roleName', data.name);
    setIsOpen(false);
  };
  let defaultValue = data.data.find((e) => e.name === roleName);
  return (
    <div className="relative">
      <label>
        <span>{t('Role')}</span>
        <input
          onFocus={() => {
            setIsOpen(true);
          }}
          onChange={onSearchParam}
          className="border rounded  w-full mb-0 p-1"
          value={defaultValue?.name}
        />
      </label>

      {isOpen && (
        <div className="absolute bottom-0 left-0 bg-white w-full transform translate-y-full z-50 pl-0 block ">
          <ul className="border rounded divide-y overflow-y-scroll max-h-64 mt-2">
            {data.data
              .filter((e) => e.name.toLowerCase().includes(searchParam.toLowerCase()))
              .map((e) => {
                return (
                  <Fragment key={e.id}>
                    <button
                      onClick={(x) => {
                        onClick(e);
                      }}
                      type="button"
                      className={`${
                        roleName === e.name ? 'bg-darkbluehover text-white' : ''
                      } w-full text-left block px-2 py-1 hover:bg-darkbluehover hover:text-white`}
                    >
                      {e.name}
                    </button>
                  </Fragment>
                );
              })}
          </ul>
        </div>
      )}
    </div>
  );
}
